import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle, Rocket } from "lucide-react";
import apiClient, { getErrorMessage } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import logo from "@/assets/logo.png";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", message: "Missing verification token." }); return; }
    apiClient.post("/auth/verify-magic-link", { token })
      .then(({ data }) => {
        localStorage.setItem("token", data.access_token);
        setUser(data.user);
        setState({ status: "success", message: `Welcome, ${data.user.first_name}!` });
        setTimeout(() => navigate("/dashboard", { replace: true }), 1500);
      })
      .catch((err) => setState({ status: "error", message: getErrorMessage(err, "Verification failed") }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid-overlay flex items-center justify-center px-5">
      <div className="w-full max-w-md glass rounded-3xl p-10 text-center animate-in-up">
        <img src={logo} alt="Pit Lane Lounge" className="h-24 mx-auto mb-6" />
        {state.status === "loading" && (
          <><Loader2 className="w-10 h-10 mx-auto text-cyan-400 animate-spin mb-4" /><p className="text-slate-300">Verifying your email…</p></>
        )}
        {state.status === "success" && (
          <>
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(0,255,157,0.16)", border: "1px solid rgba(0,255,157,0.5)" }}>
              <CheckCircle2 className="w-8 h-8" style={{ color: "#00ff9d" }} />
            </div>
            <h2 className="font-display text-2xl font-bold text-white mb-2">Email verified</h2>
            <p className="text-slate-300 mb-4">{state.message}</p>
            <p className="text-slate-500 text-sm flex items-center justify-center gap-2"><Rocket className="w-4 h-4" /> Redirecting to your dashboard…</p>
          </>
        )}
        {state.status === "error" && (
          <>
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-4" style={{ background: "rgba(255,46,151,0.16)", border: "1px solid rgba(255,46,151,0.5)" }}>
              <XCircle className="w-8 h-8" style={{ color: "#ff2e97" }} />
            </div>
            <h2 className="font-display text-2xl font-bold text-white mb-2">Verification failed</h2>
            <p className="text-slate-300 mb-6">{state.message}</p>
            <Link to="/login" className="neon-btn inline-block px-6 py-3" data-testid="verify-back-to-login">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
